import { useMemo } from 'react';

import { useBizyPageContextStore } from '../store/use-bizy-page-context-store';
import { useBizyGlobalChat } from './use-bizy-global-chat';

export function useBizySidePanelChat() {
	const context = useBizyPageContextStore((state) => state.context);

	const extraContext = useMemo(() => {
		return {
			bizy_page_name: context.pageName,
			bizy_page_type: context.pageType,
			...(context.pageData || {}),
		};
	}, [context.pageData, context.pageName, context.pageType]);

	return useBizyGlobalChat({ extraContext });
}
